export default "__VITE_ASSET__DvtBnjhV__"